import { Icon } from 'Components';
import styles from './Logo.module.scss';

const Logo = () => {
	return (
		<div className={styles.logo}>
			<Icon type="newLogo" role="img" />
		</div>
	);
};

export default Logo;
